import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetRefundUserManualLink,
	GetRefundUserManualLinkModel,
} from 'domain/usecases/private/external-links/user-manual/get-refund-user-manual';

export class RemoteGetRefundUserManualLink implements GetRefundUserManualLink {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetRefundUserManualLinkModel>,
	) {}

	async get(): Promise<GetRefundUserManualLinkModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
